import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getOutboundManifestAPI } from '../../api-services/outboundManifest.api';
import { dateTimeFormat } from '../../utils/Utils';

const OutboundManifestPage = (): ReactElement => {
  const navigate = useNavigate();

  const [dataSource, setDataSource] = useState<any[]>([]);
  const [searchKey, setSearchKey] = useState<string>('');

  useEffect(() => {
    getOutboundManifest();
  }, []);

  const getOutboundManifest = (): void => {
    getOutboundManifestAPI().then((res: {payload: any[]}) => {
      if (res && searchKey) {
        const filteredData = res.payload.filter((data) =>
          data.flightDetails.flightNo.includes(searchKey)
        );
        setDataSource(filteredData);
      } else {
        setDataSource(res.payload);
      }
    });
  };

  const totalChargeableWeight = (data: any): number =>
    data.Local.concat(data.Transit).reduce((acc: number, value: any) => acc + parseFloat(value.chWt), 0);

  return (
    <div className="content">
      <div className="card">
        <div className="row">
          <div className="col-md-4">
            <div className="input-group flex-nowrap">
              <input
                type="text"
                className="form-control"
                placeholder="Search Flight Number"
                aria-label="awbNumber"
                aria-describedby="addon-wrapping"
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
              />
              <span
                className="input-group-text"
                id="addon-wrapping"
                onClick={getOutboundManifest}
              >
                <i className="fa fa-search cursor-pointer"/>
              </span>
            </div>
          </div>
          <div className="col-md-8 text-right">
            <button
              className="app-btn app-btn-primary"
              onClick={() => navigate('/add-outbound-manifest')}
            >
              Add Outbound Manifest
            </button>
          </div>

          <div className="col-md-12">
            <div className="table-responsive mt-3">
              <table className="mb-0 w-100">
                <thead>
                <tr>
                  <th>Sl. No</th>
                  <th>Flight No</th>
                  <th>Owner/Operator</th>
                  <th>Origin</th>
                  <th>Destination</th>
                  <th>Total No.of AWBs</th>
                  <th>Total Pcs</th>
                  <th>Gross Weight</th>
                  <th>Chargeable Weight</th>
                  <th>Created Date</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {dataSource.map((item, shipmentIdx: number) => (
                  <tr key={shipmentIdx}>
                    <td>{shipmentIdx + 1}</td>
                    <td>{item.flightDetails.flightNo}</td>
                    <td>{item.owner}</td>
                    <td>{item.pointOfLoading}</td>
                    <td>{item.pointOfUploading}</td>
                    <td>{item.totalAwb}</td>
                    <td>{item.totalPcs}</td>
                    <td>{parseFloat(item.grossWt).toFixed(2)}</td>
                    <td>{totalChargeableWeight(item).toFixed(2)}</td>
                    <td>{dateTimeFormat(item.updatedAt)}</td>
                    <td className="text-center">
                      <i
                        className="fa fa-pencil-alt text-danger cursor-pointer me-3"
                        onClick={() =>
                          navigate(`/update-outbound-manifest/${item.uuid}`)
                        }
                      />
                      <i
                        className="fa fa-file-invoice text-primary cursor-pointer"
                        onClick={() =>
                          navigate(`/outbound-manifest-invoice/${item.uuid}`)
                        }
                      />
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutboundManifestPage;
